import gql from "graphql-tag";


export const ListScheduleItems = gql`
query ListScheduleItems($competitionId: String!, $limit: Int, $nextToken: String) {
  listScheduleItems(competitionId: $competitionId, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      id
      matchId
      matchType
      competitionId
      teamId
      technicalControl {
        status
        comments
      }
      name
      robotName
      robotNumber
      group
      attempt
      beginTime
      endTime
      result
      resultUnit
    }
  } 
}
`;


export const GetCompetition = gql`
  query GetCompetition($eventId: String!, $competitionId: String!) {
    getCompetition(eventId: $eventId, competitionId: $competitionId) {
      competitionId
      code 
      date 
      i18n_title
      i18n_description
      competitionType
      attemptsLimit
      tournament {
        # competitionId
        beginTime
        lunchBeginTime
        lunchEndTime
        area
        sector
        timeOffsetInMinutes
        # hasMatches
        i18n_comments
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/public/containers/Schedule/graphql.js